import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HandsHelping = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M543.9 251.4c0-1.1.1-2.2.1-3.4 0-48.6-39.4-88-88-88H304v88c0 22.1-17.9 40-40 40s-40-17.9-40-40V128h.4c4-36 34.5-64 71.6-64h112c2.8 0 5.6.2 8.3.5l40.1-40.1c21.9-21.9 57.3-21.9 79.2 0l78.1 78.1c21.9 21.9 21.9 57.3 0 79.2L544 251.4zM192 128v120c0 39.8 32.2 72 72 72s72-32.2 72-72v-56h120c30.9 0 56 25.1 56 56 0 27.2-19.4 49.9-45.2 55 8.2 8.6 13.2 20.2 13.2 33 0 26.5-21.5 48-48 48h-2.7c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48H224c-.9 0-1.8 0-2.7-.1l-37.7 37.7c-21.9 21.9-57.3 21.9-79.2 0l-78.1-78c-21.9-21.9-21.9-57.3 0-79.2L96 258.7V224c0-53 43-96 96-96z"
  }));
});
HandsHelping.displayName = 'HandsHelping';
export var HandsHelpingDimensions = {
  height: 512,
  width: 640
};